import template from './employee_view_employment_component.html';
import * as Permissions from '../../lib/permission_utils.js';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class EmployeeViewEmploymentComponentViewModel
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.loader = ko.observable(false);
		this.employment_info = ko.observableArray();
		this.employee = ko.observable(null);
		this.employee_id = ko.observable();
		this.user_access_roles = ko.observableArray();
		this.salary_structure_types = ko.observableArray();
		this.companies = ko.observableArray();
		this.contract_types = ko.observableArray();
		this.resign_types = ko.observableArray();
		this.branches = ko.observableArray();
		this.departments = ko.observableArray();

		this.resign_employee = this.resign_employee.bind(this);

		this.selected_contract_type = ko.observable();
		this.selected_company_id = ko.observable();
		this.selected_department_id = ko.observable();
		this.selected_department_id_on_edit = ko.observable();
		this.selected_salary_structure = ko.observable();

		this.resign_type = ko.observable();
		this.pending_resignation = ko.observable(false);
		this.pending_resignation_schedule_id = ko.observable();

		this.loaded_department_company_id = ko.observable();

		this.isLoading = false;
		this.lookupsLoaded = false;
		this.lastLoadedEmployeeId = null;

		if (bindings.employee && ko.isObservable(bindings.employee))
			bindings.employee.subscribe(async (nv) => {
				if (!nv)
					return;

				this.employee(nv);
				this.employee_id(nv.employee_id);


				if (this.lastLoadedEmployeeId === nv.employee_id)
					return;

				this.lastLoadedEmployeeId = nv.employee_id;

				await this.loadPage();
			});

		if (bindings.employee_id && ko.isObservable(bindings.employee_id))
			bindings.employee_id.subscribe((nv) => { this.employee_id(nv); });

		this.logged_in_employee_id = Utils.get_local_storage_nullable('employee_id');

		this.selected_company_id.subscribe(async (nv) => {
			if ((nv) && (nv != this.loaded_department_company_id() ))
			{
				let options = {
					table: 'department',
					schema: 'public',
					limit: 1000000,
					sortfield: 'department',
					sortorder: 'asc',
					filter: [{ value: nv, op: '=', field: 'company_id' }]
				}
				let res = await Grape.fetches.getJSON('/api/record', options);
				if (res.status == 'OK')
				{
					this.departments(res.records);
					this.selected_department_id(this.selected_department_id_on_edit());
					this.loaded_department_company_id(nv);
				}
				else
				{
					Grape.alerts.alert({ type: 'error', title: tr('Error'), message: res.message });
					console.error(res.status);
				}
			}
		});

		this.loadLookups = async () => {

			if (this.lookupsLoaded)
				return;

			const [
				salaryStructures,
				companies,
				resignTypes,
				branches,
				contractTypes
			] = await Promise.all([
					Grape.fetches.getJSON('/api/record', {
						table: 'salary_structure',
						schema: 'public',
						sortfield: 'salary_structure',
						sortorder: 'asc'
				}),
				Grape.fetches.getJSON('/api/record', {
					table: 'company',
					schema: 'public'
				}),
				Grape.fetches.getJSON('/api/record', {
					table: 'resign_types',
					schema: 'public',
					limit: 1000000,
					sortfield: 'sort_order',
					sortorder: 'asc'
				}),
				Grape.fetches.getJSON('/api/record', {
					table: 'branch',
					schema: 'public',
					limit: 1000000,
					sortfield: 'branch',
					sortorder: 'asc'
				}),
				Grape.cache.get('ContractTypeLookup')
			]);

			this.salary_structure_types(salaryStructures.records);
			this.companies(companies.records);
			this.resign_types(resignTypes.records);
			this.branches(branches.records);
			this.contract_types(contractTypes);

			this.lookupsLoaded = true;
		};

		this.loadPage = async () => {
			console.log("**********inside load page*******");
		    if (this.isLoading)
		        return;

		    if (!this.employee())
		        return;

		    this.isLoading = true;
		    this.loader(true);

			console.log("loading - " + this.loader());
		    try
		    {
		        const employee = this.employee();

		        console.log(
		            'loadPage',
		            employee.employee_id,
		            new Date().toISOString()
		        );

		        const [res, res_process] = await Promise.all([
		            Grape.fetches.getJSON(
		                '/employee/employment_listing/' + employee.employee_id,
		                {}
		            ),
		            Grape.fetches.getJSON(
		                '/grape-processes/resign_employee_scheduled/active_schedules',
		                {
		                    process_name: 'resign_employee_scheduled'
		                }
		            )
		        ]);


		        this.pending_resignation(false);

		        if (res_process.new)
		        {
		            const match = res_process.new.find(
		                x => x.param.employee_id == employee.employee_id
		            );

		            if (match)
		            {
		                this.pending_resignation(true);
		                this.pending_resignation_schedule_id(
		                    match.schedule_id
		                );
		            }
		        }


		        let employment_info = res.employment_listing || [];

		        for (let i = 0; i < employment_info.length; i++)
		        {
		            let f = employment_info[i];

		            f.dates = f.date_started + ' - ';

		            if (f.date_ended)
		            {
		                f.dates += f.date_ended;
		                this.resign_type(f.resign_type);
		            }
		            else
		            {
		                f.dates += f.active
		                    ? 'Current'
		                    : 'Unknown';
		            }

		            let dep = new Department(f);

		            employment_info[i] = dep;

		            dep.array_pos = i;
		            dep.temp_department_id = f.department_id;
		            dep.temp_branch_id = dep.branch_id;
		        }

		        this.employment_info(employment_info);
		        bindings.employment_info = employment_info;


		        let roleRes = await Grape.fetches.getJSON(
		            '/api/record',
		            {
		                table: 'user_role',
		                schema: 'grape',
		                limit: 1000000,
		                sortfield: 'role_name',
		                sortorder: 'asc',
		                filter: [{
		                    value: employee.grape_user_id,
		                    op: '=',
		                    field: 'user_id'
		                }]
		            }
		        );

		        if (roleRes)
		        {
		            this.user_access_roles(roleRes.records);

		            if (Permissions.isLoggedInUser_Admin())
		            {
		                $('#btnApproveUser').hide();
		                $('#btnPromoteManager').hide();
		                $('#btnDemoteManager').hide();
		                $('#divPromoteDemoteHelp').hide();

		                let isManager = false;
		                let isGeneralManager = false;
		                let isUnverified = false;

		                roleRes.records.forEach(role => {

		                    if (role.role_name === 'manager')
		                        isManager = true;

		                    if (role.role_name === 'general_manager')
		                        isGeneralManager = true;

		                    if (role.role_name === 'unverified_user')
		                        isUnverified = true;
		                });

		                if (isManager && !isGeneralManager)
		                {
		                    $('#btnPromoteManager').show();
		                    $('#divPromoteDemoteHelp').show();
		                }

		                if (isGeneralManager)
		                {
		                    $('#btnDemoteManager').show();
		                    $('#divPromoteDemoteHelp').show();
		                }

		                if (isUnverified)
		                {
		                    $('#btnApproveUser').show();
		                }
		            }
		        }

		        if (!this.lookupsLoaded)
		        {
		            const [
		                salaryRes,
		                companyRes,
		                resignRes,
		                branchRes,
		                contractTypes
		            ] = await Promise.all([
		                Grape.fetches.getJSON('/api/record', {
		                    table: 'salary_structure',
		                    schema: 'public',
		                    sortfield: 'salary_structure',
		                    sortorder: 'asc'
		                }),
		                Grape.fetches.getJSON('/api/record', {
		                    table: 'company',
		                    schema: 'public'
		                }),
		                Grape.fetches.getJSON('/api/record', {
		                    table: 'resign_types',
		                    schema: 'public',
		                    limit: 1000000,
		                    sortfield: 'sort_order',
		                    sortorder: 'asc'
		                }),
		                Grape.fetches.getJSON('/api/record', {
		                    table: 'branch',
		                    schema: 'public',
		                    limit: 1000000,
		                    sortfield: 'branch',
		                    sortorder: 'asc'
		                }),
		                Grape.cache.get('ContractTypeLookup')
		            ]);

		            this.salary_structure_types(
		                salaryRes.records
		            );

		            this.companies(
		                companyRes.records
		            );

		            this.resign_types(
		                resignRes.records
		            );

		            this.branches(
		                branchRes.records
		            );

		            this.contract_types(
		                contractTypes
		            );

		            this.lookupsLoaded = true;
		        }
		    }
		    catch (err)
		    {
		        console.error(
		            'Employee employment load failed',
		            err
		        );

		        Grape.alerts.alert({
		            type: 'error',
		            title: tr('Error'),
		            message: tr('Failed to load employment information.')
		        });
		    }
		    finally
		    {
		        this.loader(false);
		        this.isLoading = false;
		    }
		};

		this.updateData = async () => {

			if (this.bindings.onReload instanceof Function)
				await this.bindings.onReload();

				await this.loadPage();
		};

		this.delete_employee = async () => {
			let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to delete this employee permanently? WARNING: This cannot be undone.')});
			if (response)
			{
				let res = await Grape.fetches.postJSON('/employee/delete_employee', { employee_id: this.employee_id() });
				if (res.status == 'OK')
				{
					Grape.alerts.alert({ type: 'success', message: tr('Successfully deleted employee.'), title: tr('Success', 'Success') });
					Grape.navigate('/employee/list/0');
				}
				else if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
					Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error') });
			}
		};

		this.undo_resign_employee = async (v, e) => {
			let data = ko.toJS(v);

			data.employee_id = this.employee_id();
			let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'),message: tr('Are you sure you want to undo this resignation ?')});

			if (response)
			{
				let res = await Grape.fetches.postJSON('/employee/undo_resign_employee', {employee_id: data.employee_id});
				
				if (res.status == 'OK')
				{
					Grape.alerts.alert({type: 'success', message: tr('Undo successful.'), title: tr('Success')});
					this.updateData();
				}
				else if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
			}
		};

		this.undo_scheduled_resign_employee = async (v, e) => {
			let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to undo this resignation schedule?')});

			if (response)
			{
				try {
					let res = await Grape.fetches.fetch('/api/bgworker/schedule/' + this.pending_resignation_schedule_id(), {method: 'DELETE'});

					if (res.ok == true)
					{
						Grape.alerts.alert({type: 'success', message: tr('Undo successful.'), title: tr('Success')});
						this.updateData();
					}
					else if (res.status == 'ERROR')
						Grape.alerts.apiError(res);

				} catch (err)
				{
					let message = tr('Error while Undo resignation');
					if (err.jqXHR)
					{
						message += ' (status=' + err.jqXHR.textStatus + ')';
					}
					else if (err.message)
					{
						message += ' (' + err.message + ')';
					}
					Grape.alert({type: 'danger', title: 'Error', message: message});
					return;
				}
			}
		}

		this.add_department = async(v, e) =>
		{
			this.employment_info.unshift(new Department());
			let row = $('.employment_block_root > div:first-child');

			row.find('.view').hide();
			row.find('.edit').show();
			row.find('.edit').find('.datepicker').datepicker({
				format: 'yyyy-mm-dd',
				autoclose: true
			});
		};

		this.edit_department = async (v, e) =>
		{
			this.selected_department_id_on_edit(v.department_id());
			this.selected_contract_type(v.contract_type());
			this.selected_company_id(v.company_id());
			this.selected_department_id(v.department_id());
			this.selected_salary_structure(v.salary_structure());

			let root = $(e.currentTarget).parent().parent();
			let view_row = root;
			let edit_row = root.next();

			view_row.hide();
			edit_row.show();

			edit_row.find('.datepicker').datepicker({
				format: 'yyyy-mm-dd',
				autoclose: true
			});
		};

		this.save_department = async (v, e) => {
			let view_row = $(e.currentTarget).parent().parent().prev();
			let edit_row = $(e.currentTarget).parent().parent();
			let data = ko.mapping.toJS(v);
			delete data.dates;

			data.employee_id = this.employee_id();
			data.salary_structure = this.selected_salary_structure();
			data.contract_type = $('#ddlContractType').val();

			if (data.date_ended == '') data.date_ended = null;
			if (data.date_started == '') data.date_ended = null;

			data.department_id = this.selected_department_id();
			data.company_id = this.selected_company_id();
			data.resign_type = this.resign_type();
			this.loader(true);
			let res;

			try {
				res = await Grape.fetches.postJSON('/employee/departments/edit', data);
			} catch (err) {
				if (err.responseJSON)
					res = err.responseJSON;
				else
					res = err;
			}

			this.loader(false);

			if (res.status == 'OK')
			{
				await Grape.alerts.alert({ type: 'warning', message: tr('Please make sure all dates are correct and no unknown entries are left.'), title: tr('Warning') });
				await Grape.alerts.alert({type: 'success', message: tr('Successfully saved employment.'), title: tr('Success')});
				this.updateData();
			}
			else if (res.status == 'CANT_SET_ALL_FALSE')
			{
				Grape.alerts.alert({type: 'warning', message: tr('Not saved - you cannot set all employments to inactive.'), title: tr('Denied')});
				this.loadPage();
			}
			else if (res.status == 'CANT_SET_DATE_END_NULL')
			{
				Grape.alerts.alert({ type: 'warning', message: tr('Not saved - you must enter an end date.'), title: tr('Denied') });
				this.loadPage();
			}
			else if (res.status == 'ERROR')
			{
				Grape.alerts.apiError(res);
				this.loadPage();
			}
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});

			view_row.show();
			edit_row.hide();
		};

		this.delete_department = async(v, e) =>
		{

						
			let data = ko.mapping.toJS(v);
		
			if (data.employee_department_id && data.employee_department_id != null)
			{
				delete data.dates;

				data.employee_id = this.employee_id();

				if (data.date_ended == '') data.date_ended = null;
				if (data.date_started == '') data.date_ended = null;

				let message = tr('Are you sure you want to delete this employment entry ?');

				if (data.active == true)
					message = tr('Please note: You are about to delete an active employment entry. This means the previous employment entry would be made active again. Are you sure you want to proceed to delete this employment entry ?');

				let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr(message)});
				if (response)
				{
					let res = await Grape.fetches.postJSON('/employee/departments/delete', data);

					if (res.status == 'OK')
					{
						Grape.alerts.alert({type: 'success', message: tr('Successfully deleted employment.'), title: tr('Success')});
						this.loadPage();
					}
					else if (res.status == 'NOT_ALLOWED')
						Grape.alerts.alert({type: 'warning', message: tr('A person cannot have less than one employment assigned.'), title: tr('Denied')});
					else if (res.status == 'NOT_ALLOWED_ACTIVE_DEPARTMENT')
						Grape.alerts.alert({type: 'warning', message: tr('You cannot delete this employment entry because it is currently being used.'), title: tr('Denied')});
					else if (res.status == 'ERROR')
						Grape.alerts.apiError(res);
					else
						Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});
				}
			}
			else {
				this.employment_info.shift();
			}
		};

		ko.extenders.update_company = function (target, context)
		{
			target.subscribe(async(newvalue, e) =>
			{
				let date = newvalue;
				if (context.type == 'company_id')
				{
					let res = await Grape.fetches.getJSON('/api/record', {
						table: 'department',
						schema:'public',
						limit: 1000000,
						sortfield: 'department',
						sortorder: 'asc',
						filter: [{ value: context.parent.company_id(), op: '=', field: 'company_id' }]
					},
					function (departments)
					{
						this.foo.departments(departments.records); 
						let tmp_arraypos = -1;

						if (this.employment_info != null || this.employment_info != undefined)
						{
							for (let a = 0; a < this.employment_info.length; a++)
							{
								if (isNaN(Number(this.employment_info[a].array_pos)))
									tmp_arraypos = this.employment_info[a].array_pos();
								else
									tmp_arraypos = this.employment_info[a].array_pos;

								if (tmp_arraypos == this.foo.array_pos)
									this.employment_info[a].departments(departments.records);
							}
						}
					}.bind({ foo: context.parent }));
				}
			});
		};

		let Department = function (config)
		{
			let data;
			data = $.extend({
				array_pos: '',
				active: true,
				company: '',
				company_id: ko.observable('').extend({ update_company: { parent: this, type: 'company_id' } }),
				date_ended: '',
				date_started: new Date().toJSON().slice(0, 10),
				dates: '',
				department: '',
				department_id: '',
				departments: ko.observableArray(),
				employee_department_id: null,
				contract_type: '',
				employee_code: '',
				comment: '',
				resign_type: '',
				position: '',
				salary_structure: '',
				branches: '',
				branch_id: '',
				branch: ''
			}, config);

			ko.mapping.fromJS(data, {}, this);
		};
	}

	async resign_employee(v, e)
	{
		let data = ko.toJS(v);
		await Grape.dialog.open('EmployeeResign', { employee_id: this.employee_id() });
		this.updateData();
	}

	show_employment_listing_help(v, e)
	{
		Grape.dialog.open('EmploymentListingHelp', { employee_id: this.logged_in_employee_id });
	}
}

export default {
	name: 'employee_view_employment_component',
	viewModel: EmployeeViewEmploymentComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/employee_view_employment_component'
};
